import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Email from "./register/Email";
import VerificationCode from "./register/VerificationCode";
import Password from "./register/Password";
import Confirmation from "./register/Confirmation";
import Welcome from "./welcome/Welcome";
import PageReworking from "./PageReworking";
import QuickActions from "./pages/quickactions/QuickActions";
import Prices from "./pages/prices/Prices";
import { useTranslation } from "react-i18next";

const Homepage = (): React.ReactElement => {
  const t = useTranslation(["homepage"]);

  useEffect(() => {
    t?.i18n?.changeLanguage("de_DE");
  }, []);
  return (
    <>
      <Switch>
        <Route path="/" exact>
          <Welcome />
        </Route>
        <Route path="/rework" exact>
          <PageReworking />
        </Route>
        <Route path="/dpf">
          <PageReworking />
        </Route>
        <Route path="/time-tracking">
          <PageReworking />
        </Route>
        <Route path="/shift-planning">
          <PageReworking />
        </Route>
        <Route path="/on-boarding">
          <PageReworking />
        </Route>
        <Route path="/absence">
          <PageReworking />
        </Route>
        <Route path="/hr">
          <PageReworking />
        </Route>
        <Route path="/payroll">
          <PageReworking />
        </Route>
        <Route path="/prices">
          <Prices />
        </Route>
        <Route path="/blog">
          <PageReworking />
        </Route>
        <Route path="/about">
          <PageReworking />
        </Route>
        <Route path="/careers">
          <PageReworking />
        </Route>
        <Route path="/register/email">
          <Email />
        </Route>
        <Route path="/register/confirmation">
          <Confirmation />
        </Route>
        <Route path="/register/:mail/verification/:code">
          <VerificationCode />
        </Route>
        <Route path="/register/password">
          <Password />
        </Route>
        <Route path="/reset/email">
          <Email reset />
        </Route>
        <Route path="/actions/:secureId/:resourceId/:action" exact>
          <QuickActions />
        </Route>
      </Switch>
    </>
  );
};

export default Homepage;
